import styles from './Box.module.scss'
import { ReactComponent as ChevronDown } from './chevronDown.svg'
import { ReactComponent as ChevronUp } from './chevronUp.svg'

const Box = ({
  children,
  className = '',
  title,
  isCollapsed,
  handleClick,
  hasCornerButton = false,
  cornerButtonText = 'Edit',
  onClickCornerButton
}) => (
  <div
    className={`${styles.box} ${className}`}
    onClick={() => isCollapsed && handleClick()}
    style={{ cursor: isCollapsed ? 'pointer' : 'default' }}
  >
    {hasCornerButton && (
      <button className={styles.editButton} onClick={onClickCornerButton}>
        {cornerButtonText}
      </button>
    )}
    {title && (
      <div
        className={styles.boxTitle}
        onClick={() => isCollapsed === false && handleClick()}
      >
        {title}
        {isCollapsed === true && <ChevronDown />}
        {isCollapsed === false && <ChevronUp />}
      </div>
    )}
    {children && <div className={styles.children}>{children}</div>}
  </div>
)

export default Box
